import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailMainSwitchboard } from '../../dto/trail-main-switchboard';


@Component({
  selector: 'dpi-trail-main-switchboard-detail',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-main-switchboard-detail.component.html',
  styleUrl: './trail-main-switchboard-detail.component.scss'
})
export class TrailMainSwitchboardDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailMainSwitchboardDetailComponent>);
  trailMSB: TrailMainSwitchboard;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailMainSwitchboard) {
    this.trailMSB = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }
}
